import React from 'react'

export const SectionHeading = ({children}) => {
    return (
        <div className='text-center mb-8 text-2xl text-gray-700 dark:text-gray-50 font-bold'>{children}</div>
    )
}
